import useAnalytics from '@/lib/analytics/useAnalytics';
import { useTheme } from 'next-themes';
import { parseAsString, useQueryState } from 'nuqs';
import { useEffect } from 'react';
import { useFunMode } from './FunMode/useFunMode';

export const EnableFunMode = () => {
  const [reading, setReading] = useQueryState('reading', parseAsString);
  const { funMode, setFunMode } = useFunMode();

  const { setTheme } = useTheme();
  const { track } = useAnalytics();

  useEffect(() => {
    if (reading === 'fun') {
      setFunMode({ ...funMode, enabled: true });
      setTheme('dark');

      setReading(null);
      track('fun_mode_url');
    }
  }, [reading]);

  return null;
};
